import type { RoundsAssetsMappingNest, RoundsEntityType } from "../../api/generated/graphql";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

export const roundsAssetsMappingKey = (
  systemId: number,
  roundsEntityType: RoundsEntityType,
  roundsEntityId: number,
) => `${systemId}:${roundsEntityType}:${roundsEntityId}`;

type RoundsAssetsMappings = Record<string, RoundsAssetsMappingNest | undefined>;

type RoundsAssetsMappingsState = {
  roundsAssetsMappings: RoundsAssetsMappings;
  roundsAssetsMappingsLoading: boolean;
};

type RoundsAssetsMappingsActions = {
  resetRoundsAssetsMappings: () => void;
  setRoundsAssetsMappingsLoading: (roundsAssetsMappingsLoading: boolean) => void;
  mergeRoundsAssetsMappings: (entries: RoundsAssetsMappings) => void;
};

const initialState: RoundsAssetsMappingsState = {
  roundsAssetsMappings: {},
  roundsAssetsMappingsLoading: false,
};

export const createRoundsAssetsMappingsSlice: WaterlyAppStateCreator<
  RoundsAssetsMappingsActions,
  RoundsAssetsMappingsState
> = (set) => {
  return {
    ...initialState,

    resetRoundsAssetsMappings: () =>
      set(initialState, undefined, "roundsAssetsMappings:resetRoundsAssetsMappings"),

    setRoundsAssetsMappingsLoading: (roundsAssetsMappingsLoading: boolean) =>
      set({ roundsAssetsMappingsLoading }, undefined, "roundsAssetsMappings:setRoundsAssetsMappingsLoading"),

    mergeRoundsAssetsMappings: (entries: RoundsAssetsMappings) =>
      set(
        (state) => {
          for (const [key, value] of Object.entries(entries)) {
            state.roundsAssetsMappings[key] = value;
          }
        },
        false,
        "roundsAssetsMappings:mergeRoundsAssetsMappings",
      ),
  };
};
